import React from 'react';
import { Form } from 'react-bootstrap';

const RatingSlider = ({ value, onChange }) => {
    const sliderStyles = {
        width: '100%',
        height: '10px',
        background: '#5f9ea0',
        borderRadius: '5px',
        outline: 'none',
        transition: 'background 0.3s ease',
    };

    const thumbStyles = {
        width: '100%',
        height: '10px',
        borderRadius: '5px',
        background: '#feb47b',
        cursor: 'pointer',
        transition: 'background 0.3s ease',
    };


    return (
        <div>
            <Form.Label>Rating</Form.Label>
            <Form.Range
                style={sliderStyles}
                min={1}
                max={5}
                step={0.25}
                value={value}
                onChange={(e) => onChange(Number(e.target.value))}
            />
            <div style={{ textAlign: 'center' }}>
                <strong>Rating: {value}</strong>
            </div>
        </div>
    );
};

export default RatingSlider;
